import { render, staticRenderFns } from "./DialogDirection.vue?vue&type=template&id=b5d37e1a"
import script from "./DialogDirection.vue?vue&type=script&lang=js"
export * from "./DialogDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports